"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUri = require("./Clients/Support/BaseUri");
function init(apiPath) {
    BaseUri.set(apiPath);
}
exports.init = init;
var Favorites = require("./Clients/Favorites");
exports.Favorites = Favorites;
var Global = require("./Clients/Global");
exports.Global = Global;
var OrderHistory = require("./Clients/OrderHistory");
exports.OrderHistory = OrderHistory;
var Product = require("./Clients/Product");
exports.Product = Product;
var User = require("./Clients/User");
exports.User = User;
var Util = require("./Clients/Util");
exports.Util = Util;
